import React, { useEffect, useState } from "react";
import WebLogo from "../assets/images/web-logo.svg";
// import QRCode from "../assets/images/QR-code-com.png";  // <-- больше не нужно
import { QRCodeCanvas } from "qrcode.react"; // ✅ подключаем библиотеку
import { t } from "i18next";
import Header from "../auth/Header";
import WebHeader from "../auth/WebHeader";

function NewWebVersion() {
    const [value, setValue] = useState(localStorage.getItem('lang'));

    useEffect(() => {
        const interval = setInterval(() => {
            const newValue = localStorage.getItem('lang');
            if (newValue !== value) {
                setValue(newValue);
            }
        }, 500);

        return () => clearInterval(interval);
    }, [value]);

    return (
        <div className="new_web-version" style={{ marginTop: '40px' }}>
            <WebHeader />

            <div className="video_block">
                {["RU", "EN", "ES", "PT", "TR"].includes(value || "") && (
                    <div key={value}>
                        <video
                            key={value}
                            controls
                            style={{ width: "100%", height: "100%", borderRadius: "16px" }}
                            playsInline
                        >
                            <source
                                src={
                                    value === "RU"
                                        ? "https://cryptolottery777.com/public/video/3"
                                        : value === "EN" ? `https://cryptolottery777.com/public/video/3/en`
                                            : value === "ES" ? `https://cryptolottery777.com/public/video/3/es`
                                                : value === "PT" ? `https://cryptolottery777.com/public/video/3/pt`
                                                    : value === "TR" ? `https://cryptolottery777.com/public/video/3/tr`
                                                        : ""
                                }
                            />
                            {t("Ваш браузер не поддерживает HTML-видео.")}
                        </video>
                    </div>
                )}
            </div>

            <div className="web-version_content">
                {/* ✅ вместо картинки вставляем QR-код */}
                <QRCodeCanvas
                    value="https://cryptolottery777.com"
                    size={180}
                    level="H"
                    includeMargin={true}
                />

                <div className="web-version_content__right">
                    <div className="web-version_content__right___title">
                        {t('Отсканируйте QR-код для доступа к мобильному приложению')}
                    </div>
                    <div className="web-version_content__right___info">
                        1. {t("Откройте камеру на вашем телефоне")}
                    </div>
                    <div className="web-version_content__right___info">
                        2. {t("Наведите свой телефон на этот экран")}
                    </div>
                    <div className="web-version_content__right___info">
                        3. {t("Отсканируйте QR-код")}
                    </div>
                    <div className="web-version_content__right___info">
                        4. {t("Перейдите по ссылке")}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NewWebVersion;


